import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import styles from "./item.module.scss";

export default function ItemComponent({
  product,
  order,
  setOrder,
  setTotal,
  total,
  close,
}) {
  const [cantidad, setCantidad] = useState(1);
  const [descripcion, setDescripcion] = useState("");
  const [attributesValues, setAttributesValues] = useState([]);
  const [producto, setProducto] = useState(product);

  const setSelectedMultipleAttribute = (attribute, state, child) => {
    let attributesValuesTemp = attributesValues.map((a) => {
      if (a._id === attribute._id) {
        let attributeChildValue = attribute.childs.find(
          (list) => list._id === child._id
        );

        let multipleTemp = a.multiple ? a.multiple : [];

        if (state) {
          multipleTemp.push(attributeChildValue);
        } else {
          if (
            multipleTemp.find((list) => list._id === attributeChildValue._id)
          ) {
            multipleTemp.forEach((v, i) => {
              if (v._id == attributeChildValue._id) {
                multipleTemp.splice(i, 1);
              }
            });
          }
        }

        let multiplePrice = 0;
        multipleTemp.forEach((e) => {
          if (e.price) {
            multiplePrice += e.price;
          }
        });
        return {
          ...a,
          price: multiplePrice,
          multiple: multipleTemp,
        };
      } else {
        return { ...a };
      }
    });
    setAttributesValues(attributesValuesTemp);
  };

  const setSelectedAttribute = (attribute, child) => {
    let attributesValuesTemp = attributesValues.map((a) => {
      if (a._id === attribute._id) {
        let attributeChildValue = attribute.childs.find(
          (list) => list._id === child
        );

        return {
          ...a,
          value: child,
          price: attributeChildValue.price,
          childValue: attributeChildValue,
        };
      } else {
        return { ...a };
      }
    });
    setAttributesValues(attributesValuesTemp);
  };

  const onCheckProperty = (attribute, state, child) => {
    setSelectedMultipleAttribute(attribute, state, child);
  };

  const agregar = () => {
    if (!producto || cantidad < 1) {
      alert(
        "Debe seleccionar los campos requeridos y asegurarse que la cantidad sea mayor que 0"
      );
      return;
    }

    let calc = 0;
    if (producto.extraPrice) {
      calc = cantidad * producto.extraPrice;
    } else {
      calc = cantidad * producto.price;
    }

    if (total) {
      setTotal(total + calc);
    } else {
      setTotal(calc);
    }

    setOrder([
      ...order,
      {
        qty: cantidad,
        item: producto,
        instructions: descripcion,
        description: "",
        total: calc,
      },
    ]);
    close();
  };

  const isAllowToCheck = (attribute, child) => {
    let multiples = attributesValues.find((list) => list._id === attribute._id);

    if (attribute.limit > 0 && multiples) {
      multiples = multiples.multiple;
      if (multiples) {
        if (multiples.length >= attribute.limit) {
          let isSelected =
            attributesValues.filter(
              (list) =>
                list._id === attribute._id &&
                list.multiple.find((list) => list._id === child._id)
            ).length > 0;
          if (isSelected) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  };

  const allowAdd = () => {
    let disable = 0;
    if (producto) {
      if (attributesValues) {
        attributesValues.forEach((av) => {
          let attribute = producto.attributes.find(
            (list) => list._id === av._id
          );
          if (attribute && attribute.required) {
            if (attribute.type === "radio") {
              if (!av.value) {
                disable++;
              }
            } else {
              if (!av.multiple || av.multiple.length === 0) {
                disable++;
              }
            }
          } else {
            return true;
          }
        });
      }
    } else {
      return true;
    }
    let temp = disable === 0 ? false : true;
    return temp;
  };

  const isChecked = (attribute, child) => {
    let tempCheck = attributesValues.find((list) => list._id === attribute._id);
    if (tempCheck && tempCheck.multiple) {
      let isSelected =
        attributesValues.filter(
          (list) =>
            list._id === attribute._id &&
            list.multiple.find((list) => list._id === child._id)
        ).length > 0;
      return isSelected;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (producto) {
      let productTemp = producto.price;
      attributesValues.forEach((a) => {
        if (a.price) {
          productTemp += a.price;
        } else {
          productTemp += 0;
        }
      });
      if (productTemp) {
        let productWithExtraPrice = {
          ...producto,
          extraPrice: productTemp,
          selectedAttributes: attributesValues,
        };
        setProducto(productWithExtraPrice);
      }
    }
  }, [attributesValues]);

  useEffect(() => {
    if (
      producto &&
      attributesValues.length === 0 &&
      producto.attributes.length > 0
    ) {
      let values = producto.attributes.map((a) => {
        return {
          _id: a._id,
          value: undefined,
        };
      });
      setAttributesValues(values);
    }
  }, [producto]);

  return (
    <div className={styles.item}>
      <h2>{producto.name}</h2>

      <div className={styles.itemContainer}>
        <div className="attribute-container">
          {producto &&
            producto.attributes
              .sort((a, b) => {
                return a.position - b.position;
              })
              .map((attribute) => {
                return (
                  <div className="attribute-row" key={attribute._id}>
                    <div key={attribute._id}>
                      <div className={styles.titleContainer}>
                        <label className={styles.title}>
                          {attribute.title}
                        </label>
                        {attribute.required && (
                          <span className={styles.requerido}>requerido</span>
                        )}
                      </div>
                      {attribute.limit > 0 && (
                        <div className={styles.maxDetails}>
                          Máximo {attribute.limit}
                        </div>
                      )}
                    </div>

                    {attribute.childs
                      .sort((a, b) => {
                        return a.position - b.position;
                      })
                      .map((child) => {
                        return (
                          <div key={child._id} className={styles.attrList}>
                            <label>
                              {attribute.type == "check" ? (
                                <input
                                  name="isGoing"
                                  type="checkbox"
                                  disabled={isAllowToCheck(attribute, child)}
                                  checked={isChecked(attribute, child)}
                                  onChange={() => {
                                    onCheckProperty(
                                      attribute,
                                      isChecked(attribute, child)
                                        ? false
                                        : true,
                                      child
                                    );
                                  }}
                                />
                              ) : (
                                <input
                                  type="radio"
                                  value={attribute._id}
                                  name={attribute._id}
                                  onChange={() => {
                                    setSelectedAttribute(attribute, child._id);
                                  }}
                                />
                              )}
                              <div className={styles.productAttributeName}>
                                <div>{child.title}</div>
                                <div className={styles.descriptionAttr}>
                                  {child.description
                                    ? child.description
                                    : undefined}
                                </div>
                              </div>
                            </label>
                            <span>
                              {child.price ? (
                                <NumberFormat
                                  value={child.price}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
        </div>

        <div className="form-group">
          <label htmlFor=""> Cantidad</label>
          <div className={styles.cantidadBox}>
            <div
              className={styles.menos}
              onClick={() => {
                if (cantidad > 1) {
                  setCantidad(cantidad - 1);
                }
              }}
            >
              -
            </div>
            <div className="cantidad-n">
              <NumberFormat
                thousandSeparator={true}
                value={cantidad}
                className={styles.cantidadInput}
                onValueChange={(e) => setCantidad(e.floatValue)}
              />
            </div>

            <div
              className={styles.mas}
              onClick={() => setCantidad(cantidad + 1)}
            >
              +
            </div>
          </div>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <button
          className={styles.btnAdd}
          type="submit"
          disabled={allowAdd()}
          onClick={agregar}
        >
          {" "}
          Agregar
          <span>
            <NumberFormat
              value={
                producto.extraPrice
                  ? producto.extraPrice * cantidad
                  : producto.price * cantidad
              }
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
              decimalScale={2}
              className={"price-value"}
              fixedDecimalScale={true}
            />
          </span>
        </button>
        <button className={styles.btnSalir} type="submit" onClick={close}>
          {" "}
          Salir
        </button>
      </div>
    </div>
  );
}
